// extracted by mini-css-extract-plugin
module.exports = {"adDisclosure":"_3T5MS"};